import { all, call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { pushNotification } from "utils/notifications";
import {
  getPosts,
  getUserInfo,
  getSchedule,
  loginUser,
  logoutUser,
  registerUser,
  updateUserInfo,
  getUsersList,
  uploadMedia,
  requestResetPassword,
  resetPassword,
  getUserAccount,
  modifyIds,
  authenticate,
  verifyNewIds,
  searchMedia,
  getDecryptedPayload,
  deleteSchedule,
  getPageList,
  copyPage,
  getUsersAggregateList,
  requestResetPasswordRoot,
  authenticateRoot,
  getQueryList,
  getEncryptedPayload,
  invokeWorkflow,
  uploadMediaV2,
  inviteUser
} from "../services/apis/collections/oAuthApis";
import {
  LOGIN_USER,
  LOGIN_USER_TOKEN,
  DECRYPT_TOKEN,
  ENCRYPT_TOKEN,
  VERIFY_REGISTRATION,
  VERIFY_NON_BEAMER_REGISTRATION,
  REGISTER_USER,
  REGISTER_NON_BEAMER_USER,
  REQUEST_VERIFICATION_CODE,
  GET_USER_INFO,
  INVOKE_WORKFLOW,
  GET_USER_SCHEDULE,
  UPDATE_USER_INFO,
  UPLOAD_MEDIA,
  AUTHENTICATE_USER,
  ADD_AUTH,
  VALIDATE_SCHEDULE,
  DELETE_SCHEDULE,
  LOGOUT,
  GET_PAGE,
  GET_FRIEND_PAGE,
  GET_ALL_FRIEND_PAGE,
  COPY_PAGE,
  GET_USER_AGGREGATE_INFO,
  GET_ADMIN_GROUPS,
  GET_ADMIN_GROUP_MEMBERS,
  GET_USER_BY_ID,
  GET_CUSTOMERS_LIST,
  UPDATE_CUSTOMER_BLOCK_STATUS,
  GET_AGGREGATE,
  INVITE_USER
} from "reducers/authReducer";
import { getListSuccess, getLoginError } from "actions/Auth";
import { GET_LIST, LOGIN_SUCCESS } from "actions/Auth/actionTypes";
import { GET_USERS_LIST } from "reducers/authReducer";
import { RESET_PIN } from "reducers/authReducer";
import { GET_USER_ACCOUNT } from "reducers/authReducer";
import { ADD_IDENTIFIER } from "reducers/authReducer";
import { UPDATE_IDENTIFIER } from "reducers/authReducer";
import { SHOW_PROGRESS } from "actions/Auth/actionTypes";
import { HIDE_PROGRESS } from "actions/Auth/actionTypes";
import { DELETE_IDENTIFIER } from "reducers/authReducer";
import { template, xor } from "lodash";
import { formatForRedis } from "utils/appUtil";

function* getJsonData(action: any) {
  try {
    const response = yield call(getPosts);
    if (response.data) {
      pushNotification("Get data success", "success", "TOP_CENTER", 1000);
      yield put(getListSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_CENTER", 1000);
    yield put(getLoginError());
  }
}

function* loginUserAPI(action: { payload: LoginUserPayload }) {
  const uuid = localStorage.getItem("UUID");
  const { registerRequest, email, phone, password, verificationCodePhone } =
    action.payload;
  try {
    const data = {
      userIds: [
        ...(registerRequest
          ? [
            {
              phone: phone.trim(),
            },
          ]
          : []),
        ...(action.payload.email.includes("@")
          ? [
            {
              email: email.trim(),
            },
          ]
          : [
            {
              phone: email.trim(),
            },
          ]),
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        ...(registerRequest
          ? [
            {
              typeId: 2,
              param: {
                password: verificationCodePhone,
              },
            },
          ]
          : []),
        ...[
          {
            typeId: 2,
            param: {
              password,
            },
          },
        ],
      ],
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(loginUser, { data });
    const [responseData] = response.data;
    if (responseData.authCode === "0") {
      if (
        responseData.authentications &&
        responseData.authentications.length > 0
      ) {
        const [authData] = responseData.authentications;
        localStorage.setItem("TOKEN", authData.connectionId);
        localStorage.setItem("CID", authData.connectionId);
        localStorage.setItem("RID", responseData.userId);
        localStorage.setItem("UID", authData.localUserId);
        localStorage.setItem("TYPE", "beamer");
        pushNotification("User logged in", "success", "TOP_CENTER", 1000);
        yield put({ type: LOGIN_SUCCESS });
      } else {
        yield put({ type: HIDE_PROGRESS });
        pushNotification("User not found", "error", "TOP_CENTER", 1000);
      }
    } else if (responseData.authCode === "1") {
      // redirect user to verify pin
      yield put({
        type: "REGISTRATION_SUCCESS",
        payload: { success: true, email: action.payload.email },
      });
    } else if (responseData.authCode === "3" || responseData.authCode === "4") {
      const payload = {
        ...(action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          }),
        password: action.payload.password,
        reRegisteration: true,
      };
      yield call(registerUserApi, { payload });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(
        "Email or password is incorrect",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* logoutUserAPI(action: { payload: LoginUserPayload }) {
  const connectionId = localStorage.getItem("CID");
  try {
    const data = { connectionId };
    yield call(logoutUser, { data });
    yield put({
      type: "logoutUser",
    });
  } catch (error: any) { }
}

function* loginUserTokenAPI(action: { payload: any }) {
  console.log(action);
  const { userId, deviceUdid, password } = action.payload;
  try {
    const data = {
      userIds: [
        {
          rootUserId: userId,
        },
      ],
      deviceIds: [
        {
          udid: deviceUdid,
        },
      ],
      authTypeParams: [
        {
          typeId: 1,
          param: {
            password: password,
          },
        },
      ],
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(loginUser, { data });
    const [responseData] = response.data;
    if (responseData.authCode === "0") {
      if (
        responseData.authentications &&
        responseData.authentications.length > 0
      ) {
        const [authData] = responseData.authentications;
        console.log(authData);
        localStorage.setItem("TOKEN", authData.connectionId);
        localStorage.setItem("CID", authData.connectionId);
        localStorage.setItem("RID", responseData.userId);
        localStorage.setItem("NON_BEAMER_UDID", deviceUdid);
        localStorage.setItem("NON_BEAMER_USER", userId);
        localStorage.setItem("TYPE", "nonBeamer");
        pushNotification("User logged in", "success", "TOP_CENTER", 1000);
        yield put({ type: LOGIN_SUCCESS });
      } else {
        yield put({ type: HIDE_PROGRESS });
        pushNotification("User not found", "error", "TOP_CENTER", 1000);
      }
    } else if (responseData.authCode === "1") {
      // redirect user to verify pin
      yield put({
        type: "REGISTRATION_SUCCESS",
        payload: { success: true, email: action.payload.email },
      });
    } else if (responseData.authCode === "3" || responseData.authCode === "4") {
      const payload = {
        ...(action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          }),
        password: action.payload.password,
        reRegisteration: true,
      };
      yield call(registerUserApi, { payload });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(
        "Email or password is incorrect",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* verifyRegistration(action: { payload: VerifyCodePayload }) {
  const uuid = localStorage.getItem("UUID");
  const {
    email,
    password,
    verificationCodePhone,
    registrationPayload,
  } = action.payload;
  try {
    const data = {
      userIds: [
        {
          rootUserId: registrationPayload.userId,
        },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        ...(!registrationPayload.reRegisteration
          ? [
            {
              typeId: 2,
              param: {
                password: verificationCodePhone,
              },
            },
          ]
          : []),
        ...[
          {
            typeId: 2,
            param: {
              password,
            },
          },
        ],
      ],
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(loginUser, { data });
    const [responseData] = response.data;
    if (responseData.authCode === "0") {
      if (
        responseData.authentications &&
        responseData.authentications.length > 0
      ) {
        const [authData] = responseData.authentications;
        console.log(authData);
        localStorage.setItem("TOKEN", authData.connectionId);
        localStorage.setItem("CID", authData.connectionId);
        localStorage.setItem("RID", responseData.userId);
        localStorage.setItem("UID", authData.localUserId);
        if (!registrationPayload.reRegisteration) {
          const modifyIdsResponse = yield call(getAddIdentifierAPI, {
            payload: {
              email: registrationPayload.email,
              phone: registrationPayload.phoneNumber,
              hideToast: true,
            },
          });
          if (modifyIdsResponse.status) {
            yield call(updateUserInfoApi, {
              payload: {
                firstName: registrationPayload.firstName,
                lastName: registrationPayload.lastName,
                registerRequest: true,
                email: registrationPayload.email,
                phone: registrationPayload.phoneNumber,
              },
            });

            yield call(loginUserAPI, {
              payload: {
                email,
                password: registrationPayload.password,
                phoneNumber: "+92w3123322112",
              },
            });
          } else {
            yield put({ type: HIDE_PROGRESS });
            pushNotification(
              "Email or phone number already in use. Please try with some other email or phone",
              "error",
              "TOP_CENTER",
              3000
            );
          }
        } else {
          pushNotification("User logged in", "success", "TOP_CENTER", 1000);
          yield put({ type: LOGIN_SUCCESS });
        }

      } else {
        yield put({ type: HIDE_PROGRESS });
        pushNotification("User not found", "error", "TOP_CENTER", 1000);
      }
    } else if (responseData.authCode === "1") {
      // redirect user to verify pin
      yield put({
        type: "REGISTRATION_SUCCESS",
        payload: {
          success: true,
          email: action.payload.email,
          registrationPayload: { userId: localStorage.getItem("RID") },
        },
      });
    } else if (responseData.authCode === "3" || responseData.authCode === "4") {
      const payload = {
        ...(action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          }),
        password: action.payload.password,
        reRegisteration: true,
      };
      console.log(payload);
      yield call(registerUserApi, { payload });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(
        "Email or password is incorrect",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* verifyNonBeamerRegistration(action: { payload: VerifyCodePayload }) {
  const { email, phone, password, verificationCodePhone, registrationPayload } =
    action.payload;
  try {
    let authenticateEmailResponse, authenticatePhoneResponse;
    if (localStorage.getItem("emailVerified") !== localStorage.getItem("RID")) {
      authenticateEmailResponse = yield call(authenticateNonBeamerUserAPI, {
        payload: { password },
      });
      if (authenticateEmailResponse.data[0].authCode === "2") return;
      localStorage.setItem("emailVerified", localStorage.getItem("RID"));
    }

    if (localStorage.getItem("phoneVerified") !== localStorage.getItem("RID")) {
      authenticatePhoneResponse = yield call(authenticateNonBeamerUserAPI, {
        payload: { password: verificationCodePhone },
      });
      if (authenticatePhoneResponse.data[0].authCode === "2") return;
      localStorage.setItem("phoneVerified", localStorage.getItem("RID"));
    }

    yield put({ type: SHOW_PROGRESS });
    const modifyIdsResponse = yield call(getAddIdentifierAPI, {
      payload: {
        email,
        phone,
        hideToast: true,
      },
    });

    console.log("nodify ids response", modifyIdsResponse);

    if (modifyIdsResponse.status) {
      yield call(updateUserInfoApi, {
        payload: {
          firstName: registrationPayload.firstName,
          lastName: registrationPayload.lastName,
          registerRequest: true,
          email: registrationPayload.email,
          phone: registrationPayload.phoneNumber,
        },
      });
    }

    pushNotification(
      "Registration completed successfully",
      "success",
      "TOP_CENTER",
      1000
    );

    yield put({ type: LOGIN_SUCCESS });
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* authenticateUserAPI(action: { payload: AuthenticateUserPayload }) {
  const uuid = localStorage.getItem("UUID");
  try {
    const data = {
      userIds: [
        ...(action.payload.email && action.payload.email !== ""
          ? [
            {
              email: action.payload.email.trim(),
            },
          ]
          : []),
        ...(action.payload.phoneNumber && action.payload.phoneNumber !== ""
          ? [
            {
              phone: action.payload.phoneNumber.trim(),
            },
          ]
          : []),
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: action.payload.typeId || 9,
          param: {
            password: action.payload.password,
          },
        },
      ],
    };
    yield put({ type: SHOW_PROGRESS });
    let response;
    if (action.payload.root) {
      response = yield call(authenticateRoot, { data });
    } else {
      response = yield call(authenticate, { data });
    }
    console.log(response);
    const [responseData] = response.data;
    if (responseData.authCode === "0") {
      yield put({ type: "AUTHENTICATION_SUCCESSFULL" });
    } else {
      yield put({ type: "AUTHENTICATION_FAILED" });
      pushNotification(
        "Verification Code incorrect",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  } catch (error) {
    console.log(error);
    yield put({ type: "AUTHENTICATION_FAILED" });
    pushNotification(
      "Verification Code incorrect",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}

function* authenticateNonBeamerUserAPI(action: any) {
  const uuid = localStorage.getItem("UUID");
  const userId = localStorage.getItem("NON_BEAMER_USER");
  try {
    const data = {
      userIds: [
        {
          rootUserId: userId,
        },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: 2,
          param: {
            password: action.payload.password,
          },
        },
      ],
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(authenticate, { data });
    const [responseData] = response.data;
    if (responseData.authCode === "0" || responseData.authCode === "1") {
      yield put({ type: "AUTHENTICATION_SUCCESSFULL" });
    } else {
      yield put({ type: "AUTHENTICATION_FAILED" });
      pushNotification(
        "Verification Code incorrect",
        "error",
        "TOP_CENTER",
        1000
      );
    }
    return response;
  } catch (error) {
    console.log(error);
    yield put({ type: "AUTHENTICATION_FAILED" });
    pushNotification(
      "Verification Code incorrect",
      "error",
      "TOP_CENTER",
      1000
    );
  }
}

function* verifyNewIdsAPI(action: { payload: RegisterUserPayload }) {
  const { email, phoneNumber } = action.payload;
  console.log(action);
  const live = {};

  try {
    const data = {
      userIds: [{ email }, { phone: phoneNumber }],
    };
    const response = yield call(verifyNewIds, { data });
    return response;
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* registerUserApi(action: { payload: RegisterUserPayload }) {
  console.log(action);
  yield put({ type: SHOW_PROGRESS });
  const uuid = localStorage.getItem("UUID");
  let data = {};
  try {
    if (!action.payload.reRegisteration) {
      const verifyIdsResponse = yield call(verifyNewIdsAPI, action);
      if (verifyIdsResponse.status) {
        data = {
          userIds: [],
          deviceIds: [
            {
              udid: uuid,
            },
          ],
          authTypeParams: [
            {
              typeId: 2,
              param: {
                password: action.payload.password,
                useMultiOtp: true,
                verificationChannels: [
                  ...(action.payload.email && action.payload.email !== ""
                    ? [
                      {
                        email: action.payload.email.trim(),
                      },
                    ]
                    : []),
                  ...(action.payload.phoneNumber &&
                    action.payload.phoneNumber !== ""
                    ? [
                      {
                        phone: action.payload.phoneNumber.trim(),
                      },
                    ]
                    : []),
                ],
              },
            },
          ],
        };
      } else {
        yield put({ type: HIDE_PROGRESS });
        pushNotification(
          "Email or phone number already in use",
          "error",
          "TOP_CENTER",
          1000
        );
        return;
      }
    } else {
      data = {
        userIds: [
          ...(action.payload.email && action.payload.email !== ""
            ? [
              {
                email: action.payload.email.trim(),
              },
            ]
            : []),
          ...(action.payload.phoneNumber && action.payload.phoneNumber !== ""
            ? [
              {
                phone: action.payload.phoneNumber.trim(),
              },
            ]
            : []),
        ],
        deviceIds: [
          {
            udid: uuid,
          },
        ],
        authTypeParams: [
          {
            typeId: 2,
            param: {
              password: action.payload.password,
              useMultiOtp: true,
              generatePassword: false,
              verificationChannels: [
                ...(action.payload.email && action.payload.email !== ""
                  ? [
                    {
                      email: action.payload.email.trim(),
                    },
                  ]
                  : []),
                ...(action.payload.phoneNumber &&
                  action.payload.phoneNumber !== ""
                  ? [
                    {
                      phone: action.payload.phoneNumber.trim(),
                    },
                  ]
                  : []),
              ],
            },
          },
        ],
      };
    }
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(registerUser, { data });
    console.log(response);

    const [dataObject] = response.data;
    if (response && dataObject.authCode === "1") {
      yield put({
        type: "REGISTRATION_SUCCESS",
        payload: {
          success: true,
          email: action.payload.email || action.payload.phoneNumber,
          phone: action.payload.phoneNumber,
          payload: {
            ...action.payload,
            userId: dataObject.userId || localStorage.getItem("RID"),
          },
        },
      });
      if (dataObject.userId) {
        localStorage.setItem("RID", dataObject.userId);
      }
      pushNotification("Verification Code Sent", "success", "TOP_CENTER", 1000);
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* addAuthAPI(action: { payload: AddAuth }) {
  const verifyData = {
    userIds: [],
  };
  if (action.payload.newIdentifier.includes("@")) {
    verifyData.userIds.push({ email: action.payload.newIdentifier.trim() });
  } else {
    verifyData.userIds.push({ phone: action.payload.newIdentifier.trim() });
  }
  yield put({ type: SHOW_PROGRESS });
  const response = yield call(verifyNewIds, { data: verifyData });

  if (response.status) {
    yield put({ type: "IDENTIFIER_VERIFIED", payload: true });
    const uuid = localStorage.getItem("UUID");
    const data = {
      userIds: [
        {
          rootUserId: action.payload.rootUserId,
        },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      newAuthTypeParam: {
        typeId: 13,
        param: {
          verificationChannels: [
            action.payload.newIdentifier.includes("@")
              ? {
                email: action.payload.newIdentifier.trim(),
              }
              : {
                phone: action.payload.newIdentifier.trim(),
              },
          ],
        },
      },
    };
    try {
      let response;
      if (action.payload.root) {
        response = yield call(requestResetPasswordRoot, { data });
      } else {
        response = yield call(requestResetPassword, { data });
      }
      if (response && response.status) {
        if (action.payload.pinVerification) {
          yield put({
            type: "VERIFICATION_CODE_SENT",
            payload: action.payload,
          });
        }
        yield put({ type: "RESET_EMAIL_SENT", payload: action.payload });
      } else {
        yield put({ type: HIDE_PROGRESS });
        if (action.payload.pinVerification) {
          pushNotification("Verification Failed", "error", "TOP_CENTER", 1000);
          yield put({ type: "VERIFICATION_FAILED", payload: action.payload });
        }
        pushNotification(response, "error", "TOP_CENTER", 1000);
      }
    } catch (error: any) {
      yield put({ type: HIDE_PROGRESS });
      if (action.payload.pinVerification) {
        yield put({ type: "VERIFICATION_FAILED", payload: action.payload });
      }
      console.log(error);
      pushNotification(error, "error", "TOP_CENTER", 1000);
    }
  } else {
    yield put({ type: HIDE_PROGRESS });
    pushNotification("Identifier already exist", "error", "TOP_CENTER", 1000);
  }
}

function* addNonBeamerAuthAPI(action) {
  const uuid = localStorage.getItem("NON_BEAMER_UDID");
  const userId = localStorage.getItem("NON_BEAMER_USER");
  let data = {};
  const verifyIdsResponse = yield call(verifyNewIdsAPI, action);
  if (verifyIdsResponse.status) {
    data = {
      userId: userId,
      userIds: [
        {
          email: action.payload.email,
          phone: action.payload.phoneNumber,
        },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      newAuthTypeParam: {
        typeId: 2,
        param: {
          useMultiOtp: true,
          verificationChannels: [
            { email: action.payload.email },
            { phone: action.payload.phoneNumber },
          ],
        },
      },
    };
  } else {
    yield put({ type: HIDE_PROGRESS });
    pushNotification(
      "Email or phone number already in use",
      "error",
      "TOP_CENTER",
      1000
    );
    return;
  }

  try {
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(requestResetPassword, { data });

    if (response && response.status) {
      yield put({
        type: "REGISTRATION_SUCCESS",
        payload: {
          success: true,
          email: action.payload.email || action.payload.phoneNumber,
          phone: action.payload.phoneNumber,
          payload: {
            ...action.payload,
            userId: userId || localStorage.getItem("RID"),
          },
        },
      });
      if (response.data.userId) {
        localStorage.setItem("RID", response.data.userId);
        localStorage.setItem("UUID", uuid);
      }
      pushNotification("Verification Code Sent", "success", "TOP_CENTER", 1000);
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response.message, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    yield put({ type: HIDE_PROGRESS });
    if (action.payload.pinVerification) {
      yield put({ type: "VERIFICATION_FAILED", payload: action.payload });
    }
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* requestVerificationCodeAPI(action: {
  payload: RequestVerificationCode;
}) {
  let data = {};
  const uuid = localStorage.getItem("UUID");
  if (action.payload.pinVerification) {
    let verificationChannels = [];
    if (action.payload.newIdentifier) {
      verificationChannels = [
        action.payload.newIdentifier.includes("@")
          ? {
            email: action.payload.newIdentifier.trim(),
          }
          : {
            phone: action.payload.newIdentifier.trim(),
          },
      ];
    } else {
      verificationChannels = [
        action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          },
      ];
    }
    data = {
      userIds: [
        action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: 9,
          param: {
            verificationChannels,
          },
        },
      ],
    };
  } else {
    data = {
      userIds: [
        action.payload.email.includes("@")
          ? {
            email: action.payload.email.trim(),
          }
          : {
            phone: action.payload.email.trim(),
          },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: 9,
          param: {
            verificationChannels: [
              action.payload.email.includes("@")
                ? {
                  email: action.payload.email.trim(),
                }
                : {
                  phone: action.payload.email.trim(),
                },
            ],
          },
        },
      ],
    };
  }
  try {
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(authenticate, { data });
    if (response && response.status) {
      if (action.payload.pinVerification) {
        yield put({ type: "VERIFICATION_CODE_SENT", payload: action.payload });
      }
      yield put({ type: "RESET_EMAIL_SENT", payload: action.payload });
    } else {
      yield put({ type: HIDE_PROGRESS });
      if (action.payload.pinVerification) {
        pushNotification("Verification Failed", "error", "TOP_CENTER", 1000);
        yield put({ type: "VERIFICATION_FAILED", payload: action.payload });
      }
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    yield put({ type: HIDE_PROGRESS });
    if (action.payload.pinVerification) {
      yield put({ type: "VERIFICATION_FAILED", payload: action.payload });
    }
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* resetPasswordAPI(action: { payload: ResetPassword }) {
  const uuid = localStorage.getItem("UUID");
  try {
    const data = {
      userIds: [
        action.payload.rootUserId
          ? {
            rootUserId: action.payload.rootUserId,
          }
          : action.payload.email.includes("@")
            ? {
              email: action.payload.email.trim(),
            }
            : {
              phone: action.payload.email.trim(),
            },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: action.payload.rootUserId ? 2 : 9,
          param: {
            password: action.payload.password,
          },
        },
      ],
      newAuthTypeParam: {
        typeId: 2,
        param: {
          password: action.payload.newPassword,
        },
      },
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(resetPassword, { data });
    const [responseData] = response.data;
    if (responseData && responseData.authCode === "0") {
      pushNotification(response.message, "success", "TOP_CENTER", 1000);
      yield put({ type: "PASSWORD_RESET_SUCCESSFULLY", payload: true });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response.message, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    yield put({ type: HIDE_PROGRESS });
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getAddIdentifierAPI(action: { payload: AddIdentifier }) {
  const rootUserId = localStorage.getItem("RID");
  try {
    const data = {
      userId: rootUserId,
      operations: {
        userIds: {
          add: [
            ...(action.payload.email
              ? [
                {
                  email: action.payload.email.trim(),
                },
              ]
              : []),
            ...(action.payload.phone
              ? [
                {
                  phone: action.payload.phone.trim(),
                },
              ]
              : []),
          ],
        },
      },
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(modifyIds, { data });
    if (action.payload.hideToast) {
      return response;
    }
    if (response.status) {
      pushNotification(response.message, "success", "TOP_CENTER", 1000);
      if (action.payload.email) {
        localStorage.setItem("email", action.payload.email);
      } else {
        localStorage.setItem("phone", action.payload.phone);
      }
      yield put({ type: "IDENTIFIER_ADDED", payload: true });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getDeleteIdentifierAPI(action: { payload: DeleteIdentifier }) {
  const uuid = localStorage.getItem("UUID");
  const rootUserId = localStorage.getItem("RID");
  try {
    const data = {
      userId: rootUserId,
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      operations: {
        userIds: {
          remove: [
            action.payload.email
              ? {
                email: action.payload.email.trim(),
              }
              : {
                phone: action.payload.phone.trim(),
              },
          ],
        },
      },
    };
    const response = yield call(modifyIds, { data });

    if (response.status) {
      yield put({ type: "IDENTIFIER_DELETED", payload: true });

      yield put({ type: HIDE_PROGRESS });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getUpdateIdentifierAPI(action: {
  payload: { password: any; email: any; phone: any };
}) {
  console.log(action);
  const uuid = localStorage.getItem("UUID");
  const rootUserId = localStorage.getItem("RID");
  try {
    const data = {
      userIds: [
        {
          rootUserId: rootUserId,
        },
      ],
      deviceIds: [
        {
          udid: uuid,
        },
      ],
      authTypeParams: [
        {
          typeId: 2,
          param: {
            password: action.payload.password,
          },
        },
      ],
      operations: {
        userIds: {
          update: [
            action.payload.email
              ? {
                email: action.payload.email,
              }
              : {
                phone: action.payload.phone,
              },
          ],
        },
      },
    };
    const response = yield call(modifyIds, { data });
    if (response.status) {
      pushNotification(response.message, "success", "TOP_CENTER", 1000);
      yield put({ type: "ACTION_SUCCESS", payload: true });
    } else {
      yield put({ type: "ACTION_SUCCESS", payload: true });
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getUserInfoAPI(action: any) {
  const uid = localStorage.getItem("RID");
  try {
    const data = {
      objectId: uid,
      paths: ["$"],
      returnPaths: ["$"],
      resultType: "value",
    };
    const response = yield call(getUserInfo, { data, serviceId: action.serviceId });
    if (response && response.data) {
      const user = {
        ...response.data[0][0]?.persistent?.static?.live?.alternativeIds,
        ...response.data[0][0]?.persistent?.static?.live?.profile,
        stripe: response.data[0][0]?.persistent?.static?.stripe,
      };
      if (user && user.email) localStorage.setItem("email", user.email);
      if (user && user.phone) localStorage.setItem("phone", user.phone);
      yield put({ type: "SET_USER_INFO", payload: user });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* invokeWorkflowApi(action: any) {
  const { request, callback } = action.payload;
  try {
    const response = yield call(invokeWorkflow, request);
    callback && callback(response);
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getUserInfoClientAPI(action: any) {
  const { serviceId } = action.payload;
  const uid = localStorage.getItem("RID");
  try {
    const data = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@serviceId:{'${formatForRedis(
            serviceId
          )}'}`,
          searchOptions: "TIMEOUT 10000",
        },
        list: {
          objectIds: [uid],
        },
        load: {
          profile: "$.persistent.static.live",
          roleId: "$..roleId",
          stripe: "$.persistent.static.stripe",
          serviceId: "$.serviceId",
        },
      },
      groupBy: {
        properties: ["@profile", "@serviceId", "@stripe", "@roleId"],
        reducers: [
          {
            func: "TOLIST",
            arguments: ["@objectId"],
            name: "objectIds",
          },
        ],
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {
        pagination: {
          offset: 0,
          limit: 10,
        },
      },
      filter: {
        expression: "",
      },
      anyStatus: false,
    };
    const response = yield call(getUsersAggregateList, { data });
    if (response && response.data) {
      let user = {
        objectId: undefined,
        profile: undefined,
        email: undefined,
        phone: undefined,
        profileImage: undefined,
        beamIds: undefined,
        roleId: undefined,
        department: undefined,
        stripeCustomerId: undefined,
        stripePaymentMethods: undefined,
        stripe: undefined
      };

      response.data.map((x) => {
        user.objectId = x.objectIds?.toString();

        if (x.stripe) {
          user.stripe = x.stripe
        }
        if (x.roleId) {
          user.roleId = x.roleId;
        }
        if (x.profile?.alternativeIds?.email) {
          user.email = x.profile?.alternativeIds?.email
        }
        if (x.profile?.alternativeIds?.phone) {
          user.phone = x.profile?.alternativeIds?.phone
        }
        if (x.profile?.alternativeIds?.stripeCustomerId) {
          user.stripeCustomerId = x.profile?.alternativeIds?.stripeCustomerId
        }
        if (x.profile?.profile?.stripePaymentMethods) {
          user.stripePaymentMethods = x.profile?.profile?.stripePaymentMethods
        }
        if (x.profile?.profile?.firstName || x.profile?.profile?.firstName) {
          user.profile = x.profile?.profile
        }
        if (x.profile?.beamIds?.[0]) {
          user.beamIds = x.profile?.beamIds
        }
        if (x.profile?.profile?.profileImage?.urls?.original?.url) {
          user.profileImage = x.profile?.profile?.profileImage;
        }
      });
      user = {
        ...user,
        ...user?.profile,
      };
      if (user && user.email) {
        localStorage.setItem("email", user.email);
      } else {
        localStorage.removeItem("email");
      }
      if (user && user.phone) {
        localStorage.setItem("phone", user.phone);
      } else {
        localStorage.removeItem("phone");
      }
      yield put({ type: "SET_USER_INFO", payload: user });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* getUserByIdAPI(action: any) {
  // const uid = localStorage.getItem("RID");
  const { userId, callback } = action.payload;
  try {
    const data = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `*`,
          searchOptions: "TIMEOUT 10000",
        },
        list: {
          objectIds: [userId],
        },
        load: {
          profile: "$.persistent.static.live",
          roleId: "$..roleId",
          stripe: "$.persistent.static.stripe",
          serviceId: "$.serviceId",
        },
      },
      groupBy: {
        properties: ["@profile", "@serviceId", "@stripe", "@roleId"],
        reducers: [
          {
            func: "TOLIST",
            arguments: ["@objectId"],
            name: "objectIds",
          },
        ],
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {
        pagination: {
          offset: 0,
          limit: 10,
        },
      },
      filter: {
        expression: "",
      },
      anyStatus: false,
    };
    const response = yield call(getUsersAggregateList, { data });
    if (response && response.data) {
      let user = {
        id: undefined,
        objectId: undefined,
        profile: undefined,
        email: undefined,
        phone: undefined,
        profileImage: undefined,
        beamId: undefined,
        roleId: undefined,
        department: undefined,
        stripeCustomerId: undefined,
        stripePaymentMethods: undefined,
        stripe: undefined
      };

      response.data.map((x) => {
        user.objectId = x.objectIds?.toString();
        user.id = x.objectIds?.toString();

        if (x.stripe) {
          user.stripe = x.stripe
        }
        if (x.roleId) {
          user.roleId = x.roleId;
        }
        if (x.profile?.alternativeIds?.email) {
          user.email = x.profile?.alternativeIds?.email
        }
        if (x.profile?.alternativeIds?.phone) {
          user.phone = x.profile?.alternativeIds?.phone
        }
        if (x.profile?.alternativeIds?.stripeCustomerId) {
          user.stripeCustomerId = x.profile?.alternativeIds?.stripeCustomerId
        }
        if (x.profile?.profile?.stripePaymentMethods) {
          user.stripePaymentMethods = x.profile?.profile?.stripePaymentMethods
        }
        if (x.profile?.profile?.firstName || x.profile?.profile?.firstName) {
          user.profile = x.profile?.profile
        }
        if (x.profile?.beamIds?.[0]) {
          user.beamId = x.profile?.beamIds?.[0]
        }
        if (x.profile?.profile?.profileImage?.urls?.original?.url) {
          user.profileImage = x.profile?.profile?.profileImage;
        }
      });
      user = {
        ...user,
        ...user?.profile,
      };
      callback(user);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
      callback(undefined);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
    callback(undefined);
  }
}


function* getUserAccountAPI(action: any) {
  const rootUserId = localStorage.getItem("RID");
  try {
    const data = {
      rootUserId: rootUserId,
    };
    const response = yield call(getUserAccount, { data });
    if (response && response.status) {
      const { user } = response.data;
      const userIdentifiers = {};
      if (user && user.alternativeIds) {
        const alternativeIds = user.alternativeIds;
        alternativeIds.map((obj: { [x: string]: any }) => {
          userIdentifiers[Object.keys(obj)[0]] = obj[Object.keys(obj)[0]];
        });
      }
      yield put({ type: "SET_USER_IDENTIFIERS", payload: userIdentifiers });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* updateUserInfoApi(action: {
  payload: { [x: string]: any; registerRequest?: any; silentRequest?: any };
}) {
  let live: any = {};
  Object.keys(action.payload).map((att) => (live[att] = action.payload[att]));
  delete live["registerRequest"];
  delete live["silentRequest"];

  let changes = [];
  if (live.email) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/alternativeIds/email",
      value: live.email,
    });
    changes.push({
      op: "add",
      path: "/persistent/static/metadata/notificationChannels/emails",
      value: [live.email],
    });
  }
  if (live.phone) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/alternativeIds/phone",
      value: live.phone,
    });
    changes.push({
      op: "add",
      path: "/persistent/static/metadata/notificationChannels/phones",
      value: [live.phone],
    });
  }

  if (live.stripeCustomerId) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/alternativeIds/stripeCustomerId",
      value: live.stripeCustomerId,
    });
  }
  if (live.stripePaymentMethods) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/stripePaymentMethods",
      value: live.stripePaymentMethods,
    });
  }

  if (live.lastSetupIntentId) {
    changes.push({
      op: "add",
      path: "/persistent/static/stripe/lastSetupIntentId",
      value: live.lastSetupIntentId,
    });
  }

  if (live.beamId) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/beamIds",
      value: [live.beamId],
    });
  }

  if (live.firstName) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/firstName",
      value: live.firstName,
    });
  }
  if (live.lastName) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/lastName",
      value: live.lastName,
    });
  }
  if (live.dob) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/dob",
      value: live.dob,
    });
  }
  if (live.gender) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/gender",
      value: live.gender,
    });
  }
  if (live.location) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/location",
      value: live.location,
    });
  }

  if (live.profileImage) {
    changes.push({
      op: "add",
      path: "/persistent/static/live/profile/profileImage",
      value: live.profileImage,
    });
  }

  console.log('update user', changes);

  // fix cudb registration flow
  try {
    const data = {
      header: {
        accessToken: "",
        connectionId: localStorage.getItem("CID"),
        rootUserId: localStorage.getItem("RID"),
        udid: "",
      },
      objectId: localStorage.getItem("RID"),
      changes,
    };
    yield put({ type: SHOW_PROGRESS });
    const response = yield call(updateUserInfo, { data, serviceId: live?.serviceId });
    if (response && response.status) {
      yield put({ type: HIDE_PROGRESS });
      if (!action.payload.registerRequest && !action.payload.silentRequest) {
        pushNotification(
          "User updated successfully",
          "success",
          "TOP_CENTER",
          1000
        );
      }
      yield call(getUserInfoAPI, { data, serviceId: live?.serviceId });
    } else {
      yield put({ type: HIDE_PROGRESS });
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    yield put({ type: HIDE_PROGRESS });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getUsersListApi(action: { payload: any }) {

  try {
    let response;
    if (response && response.status) {
      const resolvedData = response.data
        .map((item: { [x: string]: any[] }) => ({
          id: Object.keys(item)[0],
          obj: item[Object.keys(item)[0]][0],
        }))
        .filter(
          (item: { obj: {} }) => item.obj && Object.keys(item.obj).length > 0
        )
        .map((item: { id: any; obj: any[] }) => ({
          id: item.id,
          name: item.obj[0].persistent.static.live
            ? item.obj[0].persistent?.static?.live?.profile?.firstName +
            " " +
            item.obj[0].persistent?.static?.live?.profile?.lastName
            : "",
          firstName:
            item.obj[0].persistent?.static?.live?.profile?.firstName ?? "",
          lastName:
            item.obj[0].persistent?.static?.live?.profile?.lastName ?? "",
          gender: item.obj[0].persistent?.static?.live?.profile?.gender ?? "",
          dob: item.obj[0].persistent?.static?.live?.profile?.dob ?? "",
          email:
            item.obj[0].persistent.static.live &&
            item.obj[0].persistent?.static?.live?.alternativeIds?.email,
          phone:
            item.obj[0].persistent.static.live &&
            item.obj[0].persistent?.static?.live?.alternativeIds?.phone,
        }));
      yield put({ type: "SET_USERS_LIST", payload: resolvedData });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* uploadMediaAPI(action: { payload: any },) {
  try {
    const response = yield call(uploadMediaV2, { payload: action.payload.form, onProgress: action.payload.onProgress, onError: action.payload.onError });
    if (response && response.data) {
      const searchMediumRequest = {
        objectId: response.data.mediumId,
        paths: ["$"],
        returnPaths: ["$"],
      };
      const searchResponse = yield call(searchMedia, searchMediumRequest);
      console.log("search medium request", searchResponse);
      yield put({
        type: "ADD_FILE",
        payload: { ...searchResponse.data[0][0], isBio: action.payload.isBio },
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* decryptTokenAPI(action: { payload: any }) {
  try {
    const response = yield call(getDecryptedPayload, action.payload);
    console.log(response);
    if (response && response.data) {
      yield put({ type: "ADD_DECRYPTED_TOKEN", payload: response.data });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* encryptTokenAPI(action: { payload: any }) {
  try {
    const response = yield call(getEncryptedPayload, action.payload.data);
    if (response && response.data) {
      if (action.payload.callback) {
        action.payload.callback(response.data);
      }
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* inviteUserAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(inviteUser, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* GetAggregateDataAPI(action) {
  try {
    const { callback, requestData } = action.payload;
    const response = yield call(getUsersAggregateList, {
      data: requestData,
    });
    
    if (response && response.data) {
      if(callback)callback(response.data);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getUserScheduleAPI(action: any) {
  const userId = localStorage.getItem("RID");
  try {
    const data = {
      "select": {
        "index": {
          "searchIndex": `${process.env.REACT_APP_ECO_SYSTEM}:scheduleStatusIndex`,
          "searchQuery": `*`,
          "searchOptions": "TIMEOUT 10000",
        },
        "load": {
          "objectId": "$.objectId",
          "info": "$.info",
          "userId": "$.info.userId"
        }
      },
      "filter": {
        "expression": `exists(@userId) && @userId === '${userId}'`
      },
    };

    const response = yield call(getUsersAggregateList, { data });
    if (response && response.data) {
      yield put({ type: "SET_USER_SCHEDULE", payload: response.data });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* deleteUserScheduleAPI(action: any) {
  try {
    const data = {
      "objectId": action.payload.objectId
    };
    const response = yield call(deleteSchedule, data);
    if (response && response.status) {
      pushNotification(
        "Event deleted from calendar",
        "success",
        "TOP_CENTER",
        1000
      );
      yield call(getUserScheduleAPI, {});
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* validateScheduleAPI(action: any) {
  try {
    const data = {
      "select": {
        "index": {
          "searchIndex": `${process.env.REACT_APP_ECO_SYSTEM}:scheduleStatusIndex`,
          "searchQuery": `*`,
          "searchOptions": "TIMEOUT 10000",
        },
        "load": {
          "objectId": "$.objectId",
          "info": "$.info",
          "eventId": "$.info.calendar.eventId"
        }
      },
      "filter": {
        "expression": `exists(@eventId) && contains(@eventId, '${action.payload.eventId}')`
      },
    };

    const response = yield call(getUsersAggregateList, { data });

    if (response && response.data) {
      yield put({
        type: "VALIDATE_USER_SCHEDULE",
        payload: response.data.length > 0 && response.data?.[0]?.objectId !== undefined,
      });
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


const searchStringGenerator = (search: string) => {
  const searchSplit = search.split(" ");
  if (searchSplit.length === 1)
    return `(@title:(${formatForRedis(
      searchSplit[0]
    )}*)|@beamIds:{${formatForRedis(search)}*})`;
  else {
    let lastWord = searchSplit.pop();
    return `@title:(${searchSplit.join("&")}${lastWord !== "" ? `&%${lastWord}%` : ""
      })`;
  }
};

function* getRegularPageList(action: { payload: any }) {
  try {
    const { search } = action.payload;
    const data = {
      paths: ["$"],
      returnPaths: ["$"],
      pagination: {
        limit: 20,
        offset: 0,
      },
      searchIndex: search
        ? `${process.env.REACT_APP_ECO_SYSTEM}:pageTitleIndex`
        : `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
      searchQuery: `${search ? searchStringGenerator(search) : ""
        }@pageType:{regular}@pageMembers:{${localStorage.getItem("RID")}}`,
      searchOptions: search ? "SORTBY createdAt DESC" : "SORTBY updatedAt DESC",
    };
    const response = yield call(getPageList, {
      data,
    });
    if (response && response.status) {
      const resolvedData = response.data.map(
        (page) =>
          page[Object.keys(page)[0]][0][0] &&
          page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
            ?.title && {
            pageId: Object.keys(page)[0],
            title:
              page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
                ?.title,
            members:
              page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
                ?.members?.users,
            organization:
              page[Object.keys(page)[0]][0][0]?.persistent.static.organization,
          }
      );
      yield put({ type: "SET_USER_SEARCH_PAGE", payload: resolvedData });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}


function* getAdminGroupList(action: { payload: any }) {
  try {
    const { search, serviceId } = action.payload;

    const data = {
      "select": {
        "index": {
          "searchIndex": `${process.env.REACT_APP_ECO_SYSTEM}:query:bulk`,
          "searchQuery": `(@name:(${search}*))@partitions:{org\\:${formatForRedis(serviceId)}}`
        },
        "load": {
          "objectId": "$.objectId",
          "info": "$.info",
          "objectType": "$.info.bulk.objectType",
          "createdAt": "$.info.createdAt"
        }
      },
      "sortBy": {
        "properties": [
          {
            "field": "@createdAt",
            "order": "ASC"
          }
        ],
        "max": 100000
      },
      "result": {}
    };


    const response = yield call(getUsersAggregateList, { data });
    if (response && response.status) {
      yield put({ type: "SET_SEARCH_ADMIN_GROUP", payload: response.data });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getAdminGroupMember(action: { payload: any }) {
  try {
    const { queryId, callback } = action.payload;
    const data = {
      "paths": [
        "$"
      ],
      "returnPaths": [
        "$"
      ],
      "resultType": "value",
      "objectId": queryId
    }
    const response = yield call(getQueryList, { data });
    if (response && response.status) {
      if (callback) callback(response);
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

const processLastSent = (page) => {
  if (page) {
    let lastSent;
    const groups = page?.persistent?.static?.metadata?.members?.groups ?? {};
    const userGroups = [];
    Object.keys(groups).map((groupName) => {
      if (
        (groups[groupName]?.userIds ?? []).indexOf(
          localStorage.getItem("RID")
        ) !== -1
      )
        userGroups.push(groupName);
    });
    for (let group of ["members", ...userGroups]) {
      if (
        !lastSent ||
        new Date(
          page.nonpersistent?.dynamic?.metadata?.lastSent?.[group]?.updatedAt ??
          1970
        ).getTime() > new Date(lastSent.updatedAt).getTime()
      ) {
        lastSent = page?.nonpersistent?.dynamic?.metadata?.lastSent?.[group];
      }
    }
    page.lastSent = lastSent;
    page.lastRead =
      page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
      localStorage.getItem("RID")
      ];
    const memberActivity = Object.keys(
      page?.nonpersistent?.dynamic?.metadata?.lastReadUser ?? {}
    );
    let readBy = {};
    if (memberActivity) {
      memberActivity.map((x) => {
        if (
          page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
            ?.pageMessageId ??
          false
        ) {
          if (
            !readBy[
            page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
              ?.pageMessageId
            ]
          )
            readBy[
              page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[
                x
              ]?.pageMessageId
            ] = [];
          readBy[
            page?.nonpersistent?.dynamic?.metadata?.lastReadUser?.[x]
              ?.pageMessageId
          ].push(x);
        }
      });
    }
    page.currentUserRole =
      page?.persistent?.static?.metadata?.members?.users?.[
        localStorage.getItem("RID")
      ]?.role ?? "edit";
    page.readBy = readBy;
  }
  return page;
};

function* getFriendPage(action: { payload: any }) {
  try {
    const { friendUserId } = action.payload;
    const data = {
      paths: ["$"],
      returnPaths: ["$"],
      pagination: {
        limit: 10,
        offset: 0,
      },
      searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
      searchQuery: `@pageType:{friend}@pageMembers:{${localStorage.getItem(
        "RID"
      )}}@pageMembers:{${friendUserId}}`,
      searchOptions: "SORTBY updatedAt DESC",
    };
    const response = yield call(getPageList, {
      data,
    });
    if (response && response.status) {
      let resolvedData = response.data.map(
        (page) =>
          page[Object.keys(page)[0]][0][0] && {
            pageId: Object.keys(page)[0],
            members:
              page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
                ?.members?.users,
            memberActive: true,
            ...page[Object.keys(page)[0]][0][0],
          }
      );

      resolvedData = resolvedData.map((page) => {
        page = processLastSent(page);
        return page;
      });

      yield put({
        type: "SET_FRIEND_SEARCH_PAGE",
        payload: { pages: resolvedData, friendUserId },
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* getAllFriendPages(action: { payload: any }) {
  try {
    const data = {
      paths: ["$"],
      returnPaths: ["$"],
      pagination: {
        limit: 10,
        offset: 0,
      },
      searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:pageUpdatedAtIndex`,
      searchQuery: `@pageType:{friend}@pageMembers:{${localStorage.getItem(
        "RID"
      )}}`,
      searchOptions: "SORTBY updatedAt DESC",
    };
    const response = yield call(getPageList, {
      data,
    });
    if (response && response.status) {
      let resolvedData = response.data.map(
        (page) =>
          page[Object.keys(page)[0]][0][0] && {
            pageId: Object.keys(page)[0],
            memberActive: true,
            ...page[Object.keys(page)[0]][0][0],
            members:
              page[Object.keys(page)[0]][0][0]?.persistent.static.metadata
                ?.members?.users,
          }
      );

      resolvedData = resolvedData.map((page) => {
        page = processLastSent(page);
        return page;
      });

      yield put({
        type: "SET_ALL_FRIEND_SEARCH_PAGE",
        payload: resolvedData,
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* copyMergePage(action: { payload: any }) {
  try {
    const data = action.payload;
    const response = yield call(copyPage, {
      data,
    });
    if (response && response.status) {
      console.log("copy page response", response);
      yield put({
        type: "SET_COPY_PAGE",
        payload: response.data,
      });
    } else {
      pushNotification(response, "error", "TOP_CENTER", 1000);
    }
  } catch (error: any) {
    console.log(error);
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

// Customer management saga functions
function* getCustomersListAPI(action: any) {
  try {
    const { search = '', sort = { active: 'name', direction: 'asc' }, page = { currentPageIndex: 0, itemOnPageCount: 10 } } = action.payload || {};

    // This would typically make an API call, but since we're using WebSocket pattern,
    // we'll dispatch the action to trigger the WebSocket request
    yield put({
      type: "GET_CUSTOMERS_LIST_SUCCESS",
      payload: [], // This will be populated by the WebSocket response
    });
  } catch (error: any) {
    console.log(error);
    yield put({
      type: "GET_CUSTOMERS_LIST_FAILURE",
      payload: error.message,
    });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* updateCustomerBlockStatusAPI(action: any) {
  try {
    const { customerId, isBlocked } = action.payload;

    yield put({
      type: "UPDATE_CUSTOMER_BLOCK_STATUS_SUCCESS",
      payload: { customerId, isBlocked },
    });
  } catch (error: any) {
    console.log(error);
    yield put({
      type: "UPDATE_CUSTOMER_BLOCK_STATUS_FAILURE",
      payload: error.message,
    });
    pushNotification(error, "error", "TOP_CENTER", 1000);
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_PAGE, getRegularPageList);
  yield takeLatest(GET_ADMIN_GROUPS, getAdminGroupList);
  yield takeLatest(GET_ADMIN_GROUP_MEMBERS, getAdminGroupMember);
  yield takeLatest(COPY_PAGE, copyMergePage);
  yield takeLatest(GET_FRIEND_PAGE, getFriendPage);
  yield takeLatest(GET_ALL_FRIEND_PAGE, getAllFriendPages);
  yield takeLatest(GET_USER_SCHEDULE, getUserScheduleAPI);
  yield takeLatest(VALIDATE_SCHEDULE, validateScheduleAPI);
  yield takeLatest(DELETE_SCHEDULE, deleteUserScheduleAPI);
  yield takeLatest(GET_LIST, getJsonData);
  yield takeEvery(LOGIN_USER, loginUserAPI);
  yield takeEvery(LOGOUT, logoutUserAPI);
  yield takeEvery(LOGIN_USER_TOKEN, loginUserTokenAPI);
  yield takeEvery(VERIFY_REGISTRATION, verifyRegistration);
  yield takeEvery(VERIFY_NON_BEAMER_REGISTRATION, verifyNonBeamerRegistration);
  yield takeEvery(REGISTER_USER, registerUserApi);
  yield takeEvery(REGISTER_NON_BEAMER_USER, addNonBeamerAuthAPI);
  yield takeEvery(RESET_PIN, resetPasswordAPI);
  yield takeEvery(REQUEST_VERIFICATION_CODE, requestVerificationCodeAPI);
  yield takeEvery(ADD_AUTH, addAuthAPI);
  yield takeEvery(GET_USER_INFO, getUserInfoAPI);
  yield takeEvery(INVOKE_WORKFLOW, invokeWorkflowApi);
  yield takeEvery(GET_USER_AGGREGATE_INFO, getUserInfoClientAPI);
  yield takeEvery(GET_USER_BY_ID, getUserByIdAPI);
  yield takeEvery(GET_USER_ACCOUNT, getUserAccountAPI);
  yield takeEvery(ADD_IDENTIFIER, getAddIdentifierAPI);
  yield takeEvery(UPDATE_IDENTIFIER, getUpdateIdentifierAPI);
  yield takeEvery(UPDATE_USER_INFO, updateUserInfoApi);
  yield takeEvery(GET_USERS_LIST, getUsersListApi);
  yield takeEvery(UPLOAD_MEDIA, uploadMediaAPI);
  yield takeEvery(AUTHENTICATE_USER, authenticateUserAPI);
  yield takeEvery(DELETE_IDENTIFIER, getDeleteIdentifierAPI);
  yield takeEvery(GET_CUSTOMERS_LIST, getCustomersListAPI);
  yield takeEvery(UPDATE_CUSTOMER_BLOCK_STATUS, updateCustomerBlockStatusAPI);
  yield takeEvery(GET_AGGREGATE, GetAggregateDataAPI);
  yield takeEvery(INVITE_USER, inviteUserAPI);
  yield takeEvery(DECRYPT_TOKEN, decryptTokenAPI);
  yield takeEvery(ENCRYPT_TOKEN, encryptTokenAPI);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
